import PropTypes from 'prop-types'
import { get } from 'lodash'

import Typography from '../../typography'
import RawHTML from '../../../common/raw-html'

const About = ({ course, ...attrs }) => {
  const hasAbout = (get(course, 'about', '') || '').trim().length > 0

  return hasAbout
    ? <div
      {...attrs}>
      <Typography
        size={'four'}
        weight={'black'}
        className={'mb-4'}>
        Acerca del curso
      </Typography>
      <Typography
        tag={'div'}
        size={'three'}
        weight={'regular'}>
        <RawHTML
          html={course.about} />
      </Typography>
    </div>
    : null
}

About.propTypes = {
  course: PropTypes.object
}

export default About
